import router from "../router";
import axios from "../store/axios";
import jwt from "jsonwebtoken";
import setAuthToken from "../utils/setAuthToken";
import Swal from "sweetalert2";
``;

const url = process.env.VUE_APP_API_URL;
const key = process.env.VUE_APP_JWT_KEY;

export default {
  state: {
    user: null,
    loading: false,
    merchant: {},
    agents: [],
  },
  actions: {
    // login({ commit }, data) {
    //   commit("setLoading", true);
    //   fetch(`${url}/auth/loginUser`, {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: JSON.stringify(data),
    //   })
    //     .then(async (response) => {
    //       const resData = await response.json();

    //       if (!response.ok) {
    //         const error = new Error(resData.message || "An error occurred.");
    //         error.status = response.status;
    //         throw error;
    //       }

    //       const { message } = resData;
    //       commit("setNotification", { type: "success", message });

    //       localStorage.removeItem("otpCountdown");
    //       router.push(`/login/otp/${data.email}`);
    //     })
    //     .catch((err) => {
    //       const statusCode = err.status;
    //       const serverMessage = `${err.message || "An error occurred."}`;

    //       if (serverMessage.includes("Failed")) {
    //         Swal.fire({
    //           title: "Failed",
    //           text: "You have exceeded the maximum number of login attempts. Please try again in 10 minutes.",
    //           icon: "error",
    //           confirmButtonText: "OK",
    //         });
    //       } else if (statusCode === 429) {
    //         Swal.fire({
    //           title: "Failed",
    //           text: "You have exceeded the maximum number of login attempts. Please try again in 10 minutes.",
    //           icon: "error",
    //           confirmButtonText: "OK",
    //         });
    //       } else {
    //         commit("setNotification", {
    //           type: "danger",
    //           message: serverMessage,
    //         });
    //       }
    //     })
    //     .finally(() => {
    //       commit("setLoading", false);
    //     });
    // },
    async login({ commit }, data) {
      commit("setLoading", true);

      try {
        const res = await axios.post(`${url}/auth/loginUser`, data);

        const { message } = res.data;

        commit("setNotification", { type: "success", message });

        localStorage.removeItem("otpCountdown");

        router.push(`/login/otp/${data.email}`);
      } catch (err) {
        const statusCode = err.response.status;
        const serverMessage = err.response.data.message || "An error occurred.";

        if (serverMessage.includes("Failed") || statusCode === 429) {
          Swal.fire({
            title: "Failed",
            text: "You have exceeded the maximum number of login attempts. Please try again in 10 minutes.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          commit("setNotification", {
            type: "danger",
            message: serverMessage,
          });
        }
      } finally {
        commit("setLoading", false);
      }
    },
    loginOtp({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/auth/login/otp`, data)
        .then((res) => {
          const { token, message, userData } = res.data;
          commit("setNotification", { type: "success", message });
          commit("setLoading", false);
          //set axios header
          setAuthToken(token);

          //save the token in local storage
          localStorage.setItem("jwtToken", token);
          localStorage.setItem("userType", userData.userType);
          localStorage.setItem("userId", userData._id);

          //decode token and set auth user state
          const user = jwt.decode(token, key);

          commit("setUser", user);
          commit("setUserType", userData.userType);
          router.push("/dashboard");

          if (response.status === 429) {
            commit("setNotification", {
              type: "danger",
              message:
                "You have exceeded the maximum number of login attempts. Please try again in 30 minutes.",
            });
          }
        })
        .catch((err) => {
          const { message } = err.response.data;
          commit("setNotification", { type: "danger", message });
          commit("setLoading", false);
        });
    },
    createUser({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/auth/createUser`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);

          router.push("/dashboard/view-users");
        })
        .catch((err) => {
          const { message } = err.response.data;
          commit("setNotification", { type: "danger", message });
          commit("setLoading", false);
        });
    },
    editRole({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/auth/role/update`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    createMerchant({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/auth/create-merchant`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);

          router.push("/dashboard/merchants");
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    createPtspMerchant({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/auth/create-merchant`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);

          router.push("/dashboard/ptsp-merchants");
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    editMerchant({ commit }, data) {
      commit("setLoading", true);
      axios
        .put(`${url}/auth/update-merchant`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    disableMerchant({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/auth/disable-merchant`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    enableMerchant({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/auth/enable-merchant`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    getMerchant({ commit }, id) {
      commit("setLoading", true);
      commit("setMerchant", {});
      axios
        .get(`${url}/merchant/${id}`)
        .then((res) => {
          commit("setMerchant", res.data.merchant);
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    createMerchantAgent({ commit }, payload) {
      commit("setLoading", true);
      axios
        .post(`${url}/create-agent`, payload)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);

          router.push(`/dashboard/all-agents`);
          // router.push(`/dashboard/${payload.merchantId}/agents`);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
          throw err;
        });
    },
    updateAgent({ commit }, data) {
      commit("setLoading", true);
      axios
        .put(`${url}/agent/update`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    disableAgent({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/agent/disable`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    enableAgent({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/agent/enable`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    activateAgent({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/agent/activate`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    activatePND({ commit }, payload) {
      commit("setLoading", true);
      axios
        .patch(`${url}/wallet/pnd-status`, payload)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    getAllMerchantAgents({ commit }, payload) {
      commit("setLoading", true);
      axios
        .post(`${url}/merchant/get-all-agents`, payload)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setAllMerchantsAgents", res.data);
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message } = err.response.data;
          commit("setNotification", { type: "danger", message });
          commit("setLoading", false);
        });
    },
    createInstitution({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/auth/create-institution`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);

          router.push("/dashboard/institutions");
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    editInstitution({ commit }, data) {
      commit("setLoading", true);
      axios
        .put(`${url}/auth/update-institution`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    disableInstitution({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/auth/disable-institution`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    enableInstitution({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/auth/enable-institution`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    getInstitution({ commit }, id) {
      commit("setLoading", true);
      commit("setMerchant", {});
      axios
        .get(`${url}/institution/${id}`)
        .then((res) => {
          commit("setMerchant", res.data.merchant);
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    updateRole({ commit }, data) {
      commit("setLoading, true");
      commit("setLoading", true);
      axios
        .post(`${url}/user/update-role`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    disableUser({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/user/disable`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    enableUser({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/user/enable`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    changePassword({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/user/change-password`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);

          if (response.status === 429) {
            commit("setNotification", {
              type: "danger",
              message:
                "You have exceeded the maximum number of requests per minute. Please try again in a few minutes.",
            });
          }
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    adminChangeUserPassword({ commit }, data) {
      commit("setLoading", true);
      axios
        .post(`${url}/user/admin-change-password`, data)
        .then((res) => {
          commit("setNotification", {
            type: "success",
            message: res.data.message,
          });
          commit("setLoading", false);
        })
        .catch((err) => {
          const { message, errors } = err.response.data;
          commit("setNotification", { type: "danger", message });
          if (errors) {
            Object.values(errors).forEach((element) => {
              commit("setNotification", {
                type: "danger",
                message: JSON.stringify(element),
              });
            });
          }
          commit("setLoading", false);
        });
    },
    logout({ commit }) {
      commit("clearUser");
      localStorage.removeItem("jwtToken");
      router.push("/");
    },
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
    },
    clearUser(state) {
      state.user = null;
    },
    setMerchant(state, payload) {
      state.merchant = payload;
    },
    setAllMerchantsAgents(state, payload) {
      state.agents = payload.agents;
    },
  },
};
